import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

import useRouter from '@99designs/apps/spa/common/Routing/useRouter';
import redirectTo from '@99designs/apps/spa/common/Ssr/redirectTo';
import { useViewer } from '@99designs/apps/spa/common/Viewer/ViewerContext';
import { LoggedInViewerProvider } from '@99designs/apps/spa/common/Viewer/LoggedInViewerContext';

const AuthenticatedRoute = (routeProps: RouteProps) => {
    const router = useRouter();
    const viewer = useViewer();

    if (!viewer) {
        // If the url already contains params these should persist through login.
        const fromUrl = `${router.location.pathname}${router.location.search}`;
        redirectTo('/login', [{ key: 'from', value: fromUrl }]);
        return null;
    }

    return (
        <LoggedInViewerProvider viewer={viewer}>
            <Route {...routeProps} />
        </LoggedInViewerProvider>
    );
};

export default AuthenticatedRoute;
